import { validationMessagesMap } from '@Framework/components/form/FormValidator';
export default validationMessagesMap;
